import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import styled from 'styled-components';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../../../api/ApiService';
import { teamsEndpoint } from '../../../../../../api/Teams';
import Auth from '../../../../../../routes/Auth';

import { handleSelectChange, arrayUniqueFilter } from '../../../utils';

import BannerLayout from '../../../layouts/banner';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 80%;
`;

const Label = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  flex: 1;
  text-align: center;
  margin-bottom: 10px;
`;

const Line = styled.div`
  width: 100%;
  height: 35px;
  background: #52c5cd;
  position: relative;
`;

const InnerLine = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 35px;
  background: #00274c;
`;

const RedDot = styled.div`
  position: absolute;
  top: 12.5px;
  ${p => p.left && `
    left: ${p.left};
  `}
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #ff5252;
  text-align: center;
  span {
    font-family: 'Mukta Vaani';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    color: rgba(0, 27, 59, 0.94);
    position: relative;
    top: 22px;
    ${p => p.cw && `
      left: ${p.cw}px;
    `}
  }
`;

const XAxisLabel = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: rgba(0, 27, 59, 0.94);
  position: absolute;
  bottom: -28px;
  ${p => p.left && `
    left: ${p.left};
  `}
`;

class RevenuesStep3 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      prices: []
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, performanceFeedbacksGame } = this.props;
    getRequest(
      teamsEndpoint()
    ).then(res => {
      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "Expected revenue low").teams.filter(arrayUniqueFilter);

      const teams = res.body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      getRequest(
        `${process.env.REACT_APP_API_URL}team/price_forecasts/?round_number=${activeRound}&team_id=${team_id}`
      ).then(res => {

        this.setState({
          loaded: true,
          teamsToShow,
          selectedTeamId: Number(team_id),
          allTeamsCount: teams.length,
          prices: res.body.map(i => Number(i.price)).filter(i => i > 0),
        })
      })
        .catch(err => { });
    })
      .catch(err => { });
  }

  convertPriceToPosition(price) {
    if (price >= 12) {
      return `${(Math.floor(price) - 12) / 0.46 + 50}%`;
    }

    return `${(Math.floor(price) - 2) * 5}%`;
  }

  convertPriceToCW(price) {
    return (`${price}`.replace(/[^0-9]/, '').length + 1) / 2 * -5;
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      prices
    } = this.state;

    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="Revenues"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams set their product’s selling price and/or units available for sale too low to hit their revenue target`}
        subTitle="Pricing"
        previousShownErrors={previousShownErrors}
        paragraph1={(
          <p>Let’s explore pricing. Here’s the price range of what customers are willing to pay in relation to the prices that this specific team set for their product(s).</p>
        )}
        paragraph2={(
          <p>In their round feedback, these teams were advised to consider the revenue target when making pricing and production decisions.</p>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Fragment>
            <Row>
              <Label>Mobile</Label>
              <Label>Auto</Label>
            </Row>
            <Row>
              <Line>
                <InnerLine />
                {prices.map((price, index) => (
                  <RedDot key={`red-dot-${index}`} left={this.convertPriceToPosition(price)} cw={this.convertPriceToCW(price)}>
                    <span>${price}</span>
                  </RedDot>
                ))}

                <XAxisLabel left="-10px">$2</XAxisLabel>
                <XAxisLabel left="calc(50% - 15px)">$12</XAxisLabel>
                <XAxisLabel left="calc(100% - 20px)">$35</XAxisLabel>
              </Line>
            </Row>
          </Fragment>
        )}
        visualProps={{
          flexCenter: true,
          flexDirection: 'column',
          noPadding: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default RevenuesStep3;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/revenues/step3.js